// Back To 
var btn = $("#backtotop");
$(window).scroll(function () {
  if ($(window).scrollTop() > 650) {
    btn.addClass("show");
  } else {
    btn.removeClass("show");
  }
});
btn.on("click", function (e) {
  e.preventDefault();
  $("html, body").animate({ scrollTop: 0 }, "500");
});
// Stiky menu
var stickyTop = $(".sticky-grab").offset().top + 800;
$(window).on("scroll", function () {
  if ($(window).scrollTop() >= stickyTop) {
    $(".sticky-header").addClass("sticky");
  } else {
    $(".sticky-header").removeClass("sticky");
  }
});
// Parallax on Home page
function parallax() {
  var scrolled = $(window).scrollTop();
  $("body.home .parallax").css({
    "margin-top": -(scrolled * 0.32) + "px",
  });
}
//parallax();
$(window).scroll(function () {
  if ($(window).scrollTop() <= 420) {
    parallax();
  }
});
//W O W animation
function removeWow() {
  const wowElements = document.querySelectorAll(".wow");
  for (var i = 0; i < wowElements.length; i++) {
    wowElements[i].classList.remove("wow");
  }
}
window.addEventListener("resize", function () {
  var ww = window.innerWidth;
  if (ww > 1200) {
    if (typeof WOW !== "undefined") {
      var wow = new WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 10,
        mobile: false,
        live: true,
        callback: function (box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null, // optional scroll container selector, otherwise use window
      });
      wow.init();
    } else {
      removeWow();
    }
  }
});
window.dispatchEvent(new Event("resize"));
// Chrome
const isChrome =
  /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
if (isChrome) {
  document.body.classList.add("chrome");
}
document.addEventListener("DOMContentLoaded", function () {
  // let body = document.querySelector("body");
  // function insertAfter(referenceNode, newNode) {
  //   referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  // }
  // let elBack = document.createElement("span");
  // let elBack2 = document.createElement("span");
  // let secondButton = document.querySelector(
  //   ".mainMenu li.menu-item-has-children ul.sub-menu"
  // );
  // insertAfter(secondButton, elBack);
  // let secondButton2 = document.querySelector(
  //   ".mainMenu li.menu-item-has-children + li.menu-item-has-children ul.sub-menu"
  // );
  // insertAfter(secondButton2, elBack2);
  // let secondButtonBack = document.querySelector(
  //   ".mainMenu li.menu-item-has-children span"
  // );
  // let secondButtonBack2 = document.querySelector(
  //   ".mainMenu li.menu-item-has-children + li.menu-item-has-children span"
  // );

  // secondButtonBack.addEventListener("click", function (event) {
  //   //event.preventDefault();
  //   this.parentElement.classList.toggle("second");
  // });
  // secondButtonBack2.addEventListener("click", function (event) {
  //   //event.preventDefault();
  //   this.parentElement.classList.toggle("second");
  // });
  let body = document.querySelector("body");

  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  let elBack = document.createElement("span");
  let elBack2 = document.createElement("span");
  let elBack3 = document.createElement("span");

  let secondButton = document.querySelector(".mainMenu li.menu-item-has-children ul.sub-menu");
  insertAfter(secondButton, elBack);

  let secondButton2 = document.querySelector(".mainMenu li.menu-item-has-children + li.menu-item-has-children ul.sub-menu");
  insertAfter(secondButton2, elBack2);

  let secondButton3 = document.querySelector(".mainMenu li.menu-item-has-children + li.menu-item-has-children + li.menu-item-has-children ul.sub-menu");
  insertAfter(secondButton3, elBack3);

  let secondButtonBack = document.querySelector(".mainMenu li.menu-item-has-children span");
  let secondButtonBack2 = document.querySelector(".mainMenu li.menu-item-has-children + li.menu-item-has-children span");
  let secondButtonBack3 = document.querySelector(".mainMenu li.menu-item-has-children + li.menu-item-has-children + li.menu-item-has-children span");

  secondButtonBack.addEventListener("click", function (event) {
    this.parentElement.classList.toggle("second");
  });

  secondButtonBack2.addEventListener("click", function (event) {
    this.parentElement.classList.toggle("second");
  });

  secondButtonBack3.addEventListener("click", function (event) {
    this.parentElement.classList.toggle("second");
  });


  let menu_1 = document.querySelector(".menu_1");
  let menu_2 = document.querySelector(".menu_2");
  let openMenu = document.getElementById("mobileMenu");
  menu_1.addEventListener("click", function () {
    this.classList.toggle("toopen");
    openMenu.classList.toggle("open");
    body.classList.toggle("over");
  });
  menu_2.addEventListener("click", function () {
    menu_1.classList.add("toopen");
    this.classList.toggle("toopen");
    openMenu.classList.toggle("open");
    body.classList.toggle("over");
  });

  // let popupButton = document.querySelectorAll(".popup-link");
  let popupButton2 = document.querySelectorAll(".popup2");
  let popupButton3 = document.querySelectorAll(".book");
  let popupButton4 = document.querySelectorAll(".mobile-form");
  let popupButton5 = document.querySelectorAll(".co-brokering");

  // let closeButton = document.querySelector(".close1");
  let closeButton2 = document.querySelector(".close2");
  let closeButton3 = document.querySelector(".close3");
  let closeButton4 = document.querySelector(".close4");
  let closeButton5 = document.querySelector(".close5");

  // let popup = document.querySelector("#app");
  let popup2 = document.querySelector("#app_2");
  let popup3 = document.querySelector("#app_3");
  let popup4 = document.querySelector("#app_4");
  let popup5 = document.querySelector("#app_5");



  popupButton2.forEach(function (elem) {
    elem.addEventListener(
      "click",
      function () {
        event.preventDefault();
        popup2.classList.add("open");
        body.classList.add("over");
      },
      false
    );
  });
  popupButton3.forEach(function (elem) {
    elem.addEventListener(
      "click",
      function () {
        event.preventDefault();
        popup3.classList.add("open");
        body.classList.add("over");
      },
      false
    );
  });

  popupButton4.forEach(function (elem) {
    elem.addEventListener(
      "click",
      function () {
        event.preventDefault();
        popup4.classList.add("open");
        body.classList.add("over");
      },
      false
    );
  });

  popupButton5.forEach(function (elem) {
    elem.addEventListener(
      "click",
      function () {
        event.preventDefault();
        popup5.classList.add("open");
        body.classList.add("over");
      },
      false
    );
  });

  // closeButton?.addEventListener(
  //   "click",
  //   function () {
  //     popup.classList.remove("open");
  //     body.classList.remove("over");
  //   },
  //   false
  // );
  closeButton2?.addEventListener(
    "click",
    function () {
      popup2.classList.remove("open");
      body.classList.remove("over");
    },
    false
  );
  closeButton3?.addEventListener(
    "click",
    function () {
      popup3.classList.remove("open");
      body.classList.remove("over");
    },
    false
  );
  closeButton4?.addEventListener(
    "click",
    function () {
      popup4.classList.remove("open");
      body.classList.remove("over");
    },
    false
  );
  closeButton5?.addEventListener(
    "click",
    function () {
      popup5.classList.remove("open");
      body.classList.remove("over");
    },
    false
  );

  // document.addEventListener(
  //   "wpcf7mailfailed",
  //   function (event) {
  //     setTimeout(() => {
  //       // popup?.classList.remove("open");
  //       popup2?.classList.remove("open");
  //       popup3?.classList.remove("open");
  //       popup4?.classList.remove("open");
  //       body.classList.remove("over");
  //     }, 100);
  //   },
  //   false
  // );
});

if (document.body.classList.contains("home")) {
  // Pick 1
  document.addEventListener("DOMContentLoaded", function () {
    const pickUpDate = document.getElementById("pick-up-date");
    const deliveryDate = document.getElementById("delivery-date");
    pickUpDate.addEventListener("input", function () {
      if (pickUpDate.value.length > 0) {
        const selectedPickupDate = new Date(pickUpDate.value);
        pickUpDate.classList.add("full");
        deliveryDate.min = selectedPickupDate.toISOString().split('T')[0];
      } else {
        pickUpDate.classList.remove("full");
      }
      var first = deliveryDate.value;
      var second = pickUpDate.value;
      if (new Date(first) < new Date(second)) {
        alert("Delivery date must be later than pickUp Date");
        deliveryDate.value = pickUpDate.value;
      }
    });
  });
  // Pick 2
  document.addEventListener("DOMContentLoaded", function () {
    const pickUpDate = document.getElementById("pick-up-date");
    const deliveryDate = document.getElementById("delivery-date");
    deliveryDate.addEventListener("input", function () {
      if (deliveryDate.value.length > 0) {
        deliveryDate.classList.add("full");
      } else {
        deliveryDate.classList.remove("full");
      }
      var first = deliveryDate.value;
      var second = pickUpDate.value;
      if (new Date(first) < new Date(second)) {
        alert("Delivery date must be later than pickUp Date");
        deliveryDate.value = pickUpDate.value;
      }
    });
  });
}
